import { PraiseBadge } from '@ms/yammer-graphql';

import {
  PublishersOpenEventNewQuestionAction,
  PublishersOpenEventNewUpdateAction,
} from '../../domains/publishers/actions.types';

import { EventNewQuestionPublisher, EventNewUpdatePublisher, Publisher, PublisherPostType, Publishers } from './types';

const createEventThreadStarterPublisher = (id: Publisher['id']) => ({
  attachments: [],
  hasAttemptedToAttachFile: false,
  badge: PraiseBadge.THUMBSUP,
  changedGroupWhileFilesAttached: false,
  changedPostOnBehalfOfUserWhileFilesAttached: false,
  id,
  isAnnouncement: false,
  isExpanded: true,
  isGifPickerOpen: false,
  isLinkModalOpen: false,
  isTopicBarOpen: false,
  notifiedUserIds: [],
  praisedUserIds: [],
  pollOptions: [],
  topicNames: [],
  topicIds: [],
});

type OpenEventNewUpdatePublisher = (
  state: Publishers,
  payload: PublishersOpenEventNewUpdateAction['payload'] | PublishersOpenEventNewQuestionAction['payload']
) => Publishers;

const openEventNewUpdatePublisher: OpenEventNewUpdatePublisher = (
  state,
  { id, groupId, eventId, publisherInstanceId, onBehalfOfSenderId }
) => {
  const publisher: EventNewUpdatePublisher = {
    ...createEventThreadStarterPublisher(id),
    publisherInstanceId,
    eventId,
    groupId,
    onBehalfOfSenderId,
    postType: PublisherPostType.EventNewUpdate,
    isMandatoryNotification: false,
  };

  return {
    ...state,
    [id]: publisher,
  };
};

const openEventNewQuestionPublisher: OpenEventNewUpdatePublisher = (
  state,
  { id, groupId, eventId, publisherInstanceId, onBehalfOfSenderId }
) => {
  const publisher: EventNewQuestionPublisher = {
    ...createEventThreadStarterPublisher(id),
    ...state[id],
    isExpanded: true,
    publisherInstanceId,
    eventId,
    groupId,
    onBehalfOfSenderId,
    postType: PublisherPostType.EventNewQuestion,
  };

  return {
    ...state,
    [id]: publisher,
  };
};

export { openEventNewQuestionPublisher, openEventNewUpdatePublisher };
